import styled from 'styled-components';
import { SEMANTIC_COLORS } from '../../../constant/unit/color';
import { DEVICE } from '../../../constant/unit/device';
export const S = {
    Wrapper: styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100vh;
    padding: 20px;
    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};

    @media ${DEVICE.mobileM} {
      padding: 30px 20px 36px;
    }
  `,
    Img: styled.img `
    width: 200px;
    margin-bottom: 20px;
  `,
    Countdown: styled.div `
    font-size: 16px;
    font-weight: 500;
    line-height: 28px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
  `,
};
